import React, { useState, createContext, useContext, ReactNode } from 'react';

interface UseHintBarReturn {
  readonly hintText: string;
  showHint: (hintText: string) => void;
  hideHint: () => void;
}

const HintBarContext = createContext<UseHintBarReturn | undefined>(undefined);

interface HintBarProviderProps {
  children: ReactNode;
}

export const HintBarProvider: React.FC<HintBarProviderProps> = ({ children }) => {
  const [hintText, setHintText] = useState<string>('');

  const showHint = (text: string) => {
    setHintText((current) => (current === text ? current : text));
  };

  const hideHint = () => {
    setHintText('');
  };

  return (
    <HintBarContext.Provider
      value={{
        hintText,
        showHint,
        hideHint,
      }}
    >
      {children}
    </HintBarContext.Provider>
  );
};

export const useHintBar = (): UseHintBarReturn => {
  const context = useContext(HintBarContext);
  if (context === undefined) {
    throw new Error('useHintBar must be used within a HintBarProvider');
  }
  return context;
};
